const domain = process.env.REACT_APP_COOKIE_DOMAIN;
export default domain;
